import React, {useRef, useState} from 'react';
import BackupManagerComponent from './BackupManagerComponent';
import {clearAllSongsAndImport} from '../../services/songs-db';
import {SongBackupService} from '../../services/song-backup-service';
import {FaUpload, FaSave} from 'react-icons/fa';
import './BackupViewComponent.css';
import {assertWorkspaceWritable} from '../../../../shared/services/workspaceAccess';
import {useWorkspaceReadOnly} from '../../../../shared/hooks/useWorkspaceReadOnly';
import {getWorkspaceId} from '../../../../shared/services/dbUtils';

const BackupViewComponent = () => {
  const isReadOnly = useWorkspaceReadOnly();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleBackupRestore = async files => {
    assertWorkspaceWritable(getWorkspaceId());
    await clearAllSongsAndImport(files);
    window.location.reload();
  };

  const handleFileChange = async event => {
    const file = event.target.files[0];
    event.target.value = '';
    if (!file || isReadOnly || busy) return;
    if (!/\.zip$/i.test(file.name)) { setError('Wybierz plik ZIP.'); return; }
    if (!window.confirm('Przywrócić kopię z pliku ZIP? Zastąpi to wszystkie bieżące pieśni.')) return;
    setBusy(true); setError(''); setMessage('Przetwarzanie pliku…');
    try {
      assertWorkspaceWritable(getWorkspaceId());
      const files = await SongBackupService.processZippedSongs(file);
      if (!files.length) throw new Error('Plik ZIP nie zawiera pieśni w formacie TXT.');
      await handleBackupRestore(files);
    } catch (failure) { setError(failure.message || 'Nie udało się przywrócić kopii.'); }
    finally { setBusy(false); setMessage(''); }
  };

  const handleCreateBackup = async () => {
    if (busy) return;
    setBusy(true); setError(''); setMessage('Tworzenie kopii zapasowej…');
    try {
      const result = await SongBackupService.storeBackup(`Ręczna kopia ${SongBackupService.getFormattedDateTime()}`, {force: true});
      SongBackupService.downloadBlob(result.blob, result.fileName);
      setMessage('Kopia została zapisana i pobrana.');
    } catch (failure) { setError('Nie udało się utworzyć lub pobrać kopii zapasowej.'); setMessage(''); }
    finally { setBusy(false); }
  };

  return <main className="backup-view">
    <h1 className="backup-view-title">Kopie zapasowe pieśni</h1>
    <p className="backup-view-description">{isReadOnly
      ? 'Zapisz bieżący stan wszystkich pieśni. W trybie tylko do odczytu przywracanie jest niedostępne.'
      : 'Zapisz bieżący stan wszystkich pieśni albo wróć do wcześniejszej wersji.'}</p>
    <div className="backup-actions">
      <section className="backup-create-panel">
        <div className="backup-panel-copy"><h2>Utwórz kopię</h2><p>Wszystkie pieśni, pobierane od razu na dysk (ZIP).</p></div>
        <button className="backup-button backup-create-button" onClick={handleCreateBackup} disabled={busy}>
          <FaSave aria-hidden="true"/><span>Utwórz i pobierz<span className="backup-mobile-label"> kopię</span></span>
        </button>
      </section>
      {!isReadOnly && <section className="backup-import-panel">
        <div className="backup-panel-copy"><h2>Wczytaj z pliku</h2><p>Przywróć kopię z pobranego wcześniej pliku ZIP.</p></div>
        <button className="backup-button backup-download-button backup-upload-button" disabled={busy}
          onClick={() => { if (!isReadOnly) fileInputRef.current?.click(); }}>
          <FaUpload aria-hidden="true"/><span className="backup-desktop-label">Wybierz plik</span><span className="backup-mobile-label">Wczytaj z pliku ZIP</span>
        </button>
        <input aria-label="Plik kopii zapasowej" type="file" ref={fileInputRef} onChange={handleFileChange} accept=".zip" hidden/>
      </section>}
    </div>
    {isReadOnly && <p className="backup-local-note">Zapisane kopie są przechowywane w tej przeglądarce.</p>}
    {message && <p role="status" className="backup-feedback">{message}</p>}
    {error && <p role="alert" className="backup-feedback backup-error">{error}</p>}
    <BackupManagerComponent onBackupRestore={handleBackupRestore} busy={busy}/>
  </main>;
};
export default BackupViewComponent;
